module.exports = __webpack_public_path__ + "d2efee3473ee599913772107912d4d8a.jpg";